import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import { ButtonCard, SearchCard } from "../Maintenance";
import { MSpinner } from "../Shared";
import MSectionCollection from "components/Shared/MSectionCollection";
import { getTrainingSections } from "actions/user";

const TrainingResources = props => {

  useEffect(() => {
    props.getTrainingSections();
  }, []);

  if (props.fetchingTrainingSections || props.trainingSections.length == 0) {
    return <MSpinner />;
  }

  const Components = {
    ButtonCard,
    SearchCard
  };

  let Component;

  return (
    <div className="maintenance padding-page-content">
        <MSectionCollection
          sections={props.trainingSections.map(ms => ({
            title: ms.title,
            children: <Stack direction="row" flexWrap="wrap" gap={2}>
                        {ms.maintenanceCards.map(card => {
                          Component = Components[card.component];
                          return (
                            <Component 
                              key={card.id} 
                              // onClick={click}
                              icon={card.icon}
                              title={card.title}
                              subTitle={card.subTitle}
                              className={`${card.name} maintenance-card ${card.component}`}
                              pathname={card.path}
                              history={props.history}
                              actionName={card.actionName}
                            />
                          );})}
                      </Stack>
          }))}
         />
      </div> 

  );
};

TrainingResources.propTypes = {
  history: PropTypes.object,
  getTrainingSections: PropTypes.func,
  trainingSections: PropTypes.array,
  fetchingTrainingSections: PropTypes.func,
};

const mapStateToProps = state => {
  return {
      trainingSections: state.user.trainingSections,
      fetchingTrainingSections: state.user.fetchingTrainingSections,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTrainingSections() {
    dispatch(getTrainingSections());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrainingResources));